import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StylistPanel from "@/components/StylistPanel";
import { useAuth } from "@/context/AuthContext";

export default function Layout() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const isSeller = pathname.startsWith("/seller");
  const viewingAs = Boolean(user?.impersonated_by);
  const hideFooter = pathname === "/seller/onboarding";
  return (
    <div className="min-h-screen flex flex-col bg-aura-bg">
      <Navbar />
      <main className={`flex-1 ${viewingAs ? "pt-8" : ""}`}>
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
      {user && user.role === "buyer" && !isSeller && <StylistPanel />}
    </div>
  );
}
